const BaseHr = () => {
    return (
        <div style={styles.hrStyle} />
    );
};

export default BaseHr;

const styles = {
    hrStyle: {
        height: "1px",
        backgroundColor: '#979797',
        opacity: 0.5
    }
};